var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { createStyles, withStyles } from '@material-ui/core/styles';
import MuiTableRow from '@material-ui/core/TableRow';
import MuiTableHead from '@material-ui/core/TableHead';
import MuiTableSortLabel from '@material-ui/core/TableSortLabel';
import TableCell from './TableCell';
var StyledTableSortLabel = withStyles(function () {
    return createStyles({
        // eslint-disable-next-line complexity
        root: function (props) { return ({
            '&$active': __assign(__assign({}, ((props.style && props.style.head) || {})), { '&$root': {
                    '&$active': {
                        '& $icon': __assign({ fontSize: 14 }, ((props.style && props.style.head) || {})),
                    },
                } }),
            '&:hover': __assign({ opacity: 0.4 }, ((props.style && props.style.head) || {})),
        }); },
        active: function (props) { return (__assign({}, ((props.style && props.style.head) || {}))); },
        icon: function (props) { return (__assign({}, ((props.style && props.style.head) || {}))); },
    });
})(MuiTableSortLabel);
export default function TableHeader(props) {
    var classes = props.classes, order = props.order, orderBy = props.orderBy, columns = props.columns, onRequestSort = props.onRequestSort, sortable = props.sortable;
    var createSortHandler = function (property) { return function () {
        onRequestSort(property);
    }; };
    var renderSortLabel = function (column) {
        if (!sortable || (Object.prototype.hasOwnProperty.call(column, 'sortable') && !column.sortable)) {
            return column.label;
        }
        return (React.createElement(StyledTableSortLabel, { active: orderBy === column.name, direction: orderBy === column.name ? order : 'asc', onClick: createSortHandler(column.name), style: column.style, hideSortIcon: true }, column.label));
    };
    var renderLabelCell = function (column) {
        var ColumnRender = column.renderHeader;
        var content = ColumnRender ? React.createElement(ColumnRender, { value: column.label }) : renderSortLabel(column);
        return (React.createElement(TableCell, { key: column.name, align: column.align, style: column.style, sortDirection: orderBy === column.name ? order : false }, content));
    };
    return (React.createElement(MuiTableHead, null,
        React.createElement(MuiTableRow, { className: classes }, columns.map(renderLabelCell))));
}
//# sourceMappingURL=TableHeader.js.map